import { useQuery } from '@tanstack/react-query';

import { goodsTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';
import { Departments } from '@/types';

export const getGoods: goodsTypes.GetGoods = (params) => {
  return axios.get(`/goods`, { params });
};

type QueryFnType = typeof getGoods;

type UseGetGoodsOptions = {
  department: Departments;
  config?: QueryConfig<QueryFnType>;
};

export const useGetGoods = ({ config = {}, department }: UseGetGoodsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['goods', department],
    enabled: !!department,
    queryFn: () => getGoods({ department }),
  });
};
